/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jun 28 2023
 **/

export type GoogleContactListItem = {
	checked: boolean;
	consonant: string;
	displayName: string;
	displayNameLastFirst: string;
	familyName: string;
	name: string;
	username: string;
	givenName: string;
	metadata: { primary: boolean; source: { id: string; type: string } };
	unstructuredName: string;
	value: string;
};

import { atom } from "jotai";

export const SearchValue = atom<string>("");

export const GoogleInviteCheckedList = atom<string[]>([]);

export const GoogleInviteStep = atom<"ready" | "start">("ready");

export const GoogleContactList = atom<GoogleContactListItem[]>([]);

export const Friends = atom<WebServices.Friend.Friends.Data | null>([]);

export const BlockUsers = atom<WebServices.Block.List.Data | null>([]);

export const GoogleAccessToken = atom<string>("");

export const GoogleRefreshFlag = atom<boolean>(false);

export const GroupPeople = atom<{ [key: string]: WebServices.People.List.Item["users"] }>({});

export const Peoples = atom<WebServices.People.List.Item["users"]>([]);
